<template>
    <div>
        <h3>Create Your Account</h3>
        <form @submit.prevent="submitForm">
            <p>
                <label class="email" for="email">Email:</label>
                <input id="email" v-model="email" />
            </p>
            <p>
                <label class="password" for="password1">Password:</label>
                <input id="password1" v-model="password1" />
            </p>
            <p>
                <label class="password" for="password2">Confirm password:</label>
                <input id="password2" v-model="password2" />
            </p>
            <button class="button">Register</button>          
        </form>
        <br>
        <router-link to="/login" class="sign">Already registered? Go to Login</router-link> 
       
    </div> 
</template>

<script>
export default {
    data() {
        return {
            email: "",
            password1: "",
            password2: "",
        };
    },
    methods: {
        submitForm() {
            console.log(
                this.email + 
                " " + 
                this.password1 + 
                " " + 
                this.password2
            );
            if (this.password1 === this.password2) {
                fetch(
                    "https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=AIzaSyAzMfGy3Evj07jg4X8M31OVD26Ykqv-SYk",
                    {
                        method: "POST",
                        body: JSON.stringify(
                            {
                                displayName: this.email,
                                email: this.email,
                                password: this.password1,
                                returnSecureToken: true,
                            }
                        ),
                    }
                )
                 .then((response) => response.json())
                 .then((data) => {
                     if (data.error != null) {
                         console.log("ERROR: signUp");
                         console.log(data.error);
                         alert(data.error.message)
                     }
                     else {
                         alert("Successfully registered! Proceed to login page...");
                         this.$router.replace("/login");  // cannot come back to /register
                     }
                 })
                 .catch((error) => console.log(error));
            }
            else {
                alert("The passwords do not match!!!");
            }
        },
    },
};
</script>

<style scoped>
div {
    background: skyblue;
    padding: 10px;
    margin: 5px;
    text-align: center;
    font-family: Arial, Helvetica, sans-serif;
}
.email {
    margin-right: 0px;
    padding-right: 50px;
    font-family: Arial, Helvetica, sans-serif;
}
.password {
    margin-right: 25px;
}

.button {
    background-color: white;
    border: 3p;
    border-color: #4caf50;
    color:#4caf50;
    font-family:Arial, Helvetica, sans-serif;
    border-radius: 3px;
    font-size: 1rem;
}

.button:hover {
    background-color:#4caf50;
    border: 3p;
    color:white;
    font-family:Arial, Helvetica, sans-serif;
    border-radius: 3px;
    font-size: 1rem;
}
.sign {
    text-decoration: underline;
    background: none;
    color: black;
}
</style>
